const OVERLOADED_LANGUAGE_HTTP_PARAMETER_ID = 'ibe.ol-lang';

export const decorateUrlWithLangOverrideParam = (url, languageId) => {
  let decoratedUrl;

  try {
    decoratedUrl = new URL(url);
  } catch (e) {
    return url || null;
  }

  if (languageId) {
    decoratedUrl.searchParams.set(OVERLOADED_LANGUAGE_HTTP_PARAMETER_ID, languageId);
  }

  return decoratedUrl.href;
};
